import { render, staticRenderFns } from "./SalesmanFavorited.vue?vue&type=template&id=95e5a9cc"
import script from "./SalesmanFavorited.vue?vue&type=script&lang=js"
export * from "./SalesmanFavorited.vue?vue&type=script&lang=js"
import style0 from "./SalesmanFavorited.vue?vue&type=style&index=0&id=95e5a9cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports